import { STATUS_TYPE } from "taltech-styleguide";
import { ErrorScreenProps, ErrorScreen } from "./ErrorScreen";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Navigate } from "react-router-dom";

const Error404Screen: React.FC<any> = () => {
  const props: ErrorScreenProps = {
    variant: STATUS_TYPE.WARNING,
    status: 404,
    title: "Resource not found",
    message: "The page you are looking for was not found",
  };
  return (
    <>
      <AuthenticatedTemplate>
        <ErrorScreen {...props} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/" />
      </UnauthenticatedTemplate>
    </>
  );
};

export { Error404Screen };
